import { makeStyles, Text } from "@fluentui/react-components";
import * as React from "react";
import { CardSection } from "../../components/CardSection";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        padding: "2rem clamp(1rem, 5vw, 4rem)",
        width: "80%",
        margin: "0 auto",
        maxWidth: "1400px",
    },
    ul: {
        paddingLeft: "1.25rem",
        marginTop: "0.5rem",
        marginBottom: "0.5rem",
    },
    ol: {
        paddingLeft: "1.25rem",
        marginTop: "0.5rem",
        marginBottom: "0.5rem",
    }
});

export const Id = "1c417d3e-f808-4c42-94d5-650b2301aefc";
export const Title = "How to use Ianus Guard inside Model Driven Apps?";
export const Subtitle = "Explanation on how to use Ianus Guard inside Model Driven Apps";
export const Description = "Find out how to use Ianus Guard inside Model Driven Apps and what to take care of";
export const Keywords = ["developer", "model", "driven", "app"];

export const Component: React.FC = React.memo(() => {
    const styles = useStyles();

    return (
            <div className={styles.container}>
                <CardSection title="Overview">
                    <Text>
                        You can protect your PCF components and canvas apps using Ianus Guard for PCFs and Ianus Guard for Canvas Apps right now.
                        Model Driven Apps can not yet be protected as a whole, but you can put Ianus Guard for PCFs on your form, write a form script that attaches to Ianus Guard for PCFs onChange event and react to changes on "IsValid".
                        If it is false, you can lock all your form controls.
                    </Text>
                </CardSection>
            </div>
    );
});